module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _vm._m(0)
},staticRenderFns: [function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "chapter"
  }, [_c('div', {
    staticClass: "inner_page"
  }, [_c('p', {
    staticClass: "fmh",
    attrs: {
      "id": "ack"
    }
  }, [_c('span', {
    staticClass: "epub-bi"
  }, [_vm._v("Acknowledgments")])]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("It was Orson Scott Card who first introduced me to Andreas Eschbach’s books, and then to Andreas himself. I was delighted to find that I not only enjoyed reading the novels and short stories, but that I liked Andreas very much as well: he is a man of charm and intelligence. So I am grateful to Scott for that introduction, and also for the years of friendship that he and Kristine have extended to my family and to me.")]), _vm._v(" "), _c('p', {
    staticClass: "tx"
  }, [_vm._v("Das Europäische Übersetzer-Kollegium in Straelen, Germany, also deserves my special gratitude. I spent very productive weeks there while working on "), _c('span', {
    staticClass: "epub-i"
  }, [_vm._v("The Carpet Makers.")]), _vm._v(" Their reference library is superb, but the real pleasure of working there is the interaction with the staff and with the ever-changing coterie of other translators. I have seldom been in the company of more literate, intelligent, and helpful colleagues and friends.")]), _vm._v(" "), _c('p', {
    staticClass: "txs"
  }, [_vm._v("Of course, I am always thankful to my four daughters—J.R., Emily, Kathryn, and Amanda—for their support and love, for their occasional reading of my translated texts, and for their willingness to offer insightful suggestions.")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Doryl Jensen")]), _vm._v(" "), _c('p', {
    staticClass: "tni"
  }, [_vm._v("Greensboro, NC")])])])
}]}


//////////////////
// WEBPACK FOOTER
// ../node_modules/vue-loader/lib/template-compiler?{"id":"data-v-a27ef4d0","hasScoped":false,"transformToRequire":{"video":"src","source":"src","img":"src","image":"xlink:href"}}!../node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/components/xhtml/ack.vue
// module id = 66
// module chunks = 0